import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import WorkFlowStep from "./WorkFlowStep";
import WorkFlowStepUsers from "./WorkFlowStepUsers";
import GridConfig from "../GridConfig";

export default class WorkFlowSteps extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            workFlowId: props.WorkFlowId,
            solutionId: props.SolutionId,
            controllerName: 'solution/workflow/step',
            data: null,
            loading: true,
            configName: 'workflowsteps_grid',
            moduleName: 'مراحل کار'
        };
        this.state.filters = {
            workFlowId: this.state.workFlowId,
            solutionId: this.getDefaultGuid()
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <WorkFlowStep Caller={this} Id={id} WorkFlowId={this.state.workFlowId}/>
        });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <WorkFlowStep Caller={this} WorkFlowId={this.state.workFlowId} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "عنوان", show: true },
                { field: "description", caption: "توضیحات", show: true },
                { field: "parameter", caption: "پارامتر", show: true },
                { field: "step", caption: "شماره گام", show: true },
                { field: "deadlineDay", caption: "مهلت انجام", show: true },
                { field: "hasRequirementPricing", caption: "برآورد مالی", show: true },                
                { field: "createDateString", caption: "تاریخ ثبت", show: false },
                { field: "editDateString", caption: "تاریخ بروزرسانی", show: false }
            ]
        }
    }
    showStepUsers(workFlowStepId) {
        this.removeKeyDown();
        this.showComponents({ component: <WorkFlowStepUsers Caller={this} WorkFlowStepId={workFlowStepId} SolutionId={this.state.solutionId} /> });
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({
                field: f.field, flex: 3, headerName: f.caption, cellRenderer: (props) => {
                    return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)} style={{ "display": "flex", "flex-direction": "row", "align-items": "center", "gap": "2px" }} ><span style={{ "width": "16px", "height": "16px", "display": "inline-block", "border-radius": "100%", "backgroundColor": props.data.color }}></span>{props.data.title}</a>
                }
            });
            if (f.field == 'description' && f.show) t.push({ field: f.field, headerName: f.caption, flex: 2 });
            if (f.field == 'parameter' && f.show) t.push({ field: f.field, headerName: f.caption, flex: 2 });
            if (f.field == 'step' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number' });
            if (f.field == 'deadlineDay' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number' });
            if (f.field == 'hasRequirementPricing' && f.show) t.push({
                field: f.field, headerName: f.caption, cellRenderer: (props) => {
                    return props.data.hasRequirementPricing ? <span className="text-success txt-bold hand">دارد</span> : <span className="text-success txt-bold hand">ندارد</span>
                }
            });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: 'id', headerName: 'عملیات', cellRenderer: (props) => {
                return [
                    <a onClick={e => this.showStepUsers(props.data.id)} className="hand text-success">
                        <span className="nk-menu-text"><em className="icon ni ni-report-profit"></em> مسئولین و مجریان</span>
                    </a>
                ]
            }
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">مراحل کاری</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.getToolBar(false, { add: true, print: true, pdf: true, excell: true, remove: true, config:false, otherFilters: null })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}